import React from 'react'
import { Input, InputProps } from '@/components/Input'
import { Icon } from '@/icons'

export const SearchInput = <TName,>(props: InputProps<TName>) => {
  return (
    <Input
      type="text"
      leftIcon={<Icon name="search" />}
      name="search"
      {...props}
    />
  )
}
